export function Edit(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.8557 17.4276C4.12229 17.4341 4.33686 17.6487 4.34336 17.9153L4.37383 19.1649L0.437834 19.8596C0.30631 19.8828 0.175649 19.7939 0.145993 19.6611C0.138904 19.6294 0.138111 19.5968 0.14366 19.5654L0.838293 15.6294L2.08793 15.6599C2.35452 15.6664 2.5691 15.8809 2.5756 16.1475L2.59445 16.9211C2.60095 17.1877 2.81553 17.4023 3.08212 17.4088L3.8557 17.4276ZM17.001 6.53771L5.21564 18.3231L5.18518 17.0735C5.17868 16.8069 4.9641 16.5923 4.69751 16.5858L3.92394 16.5669C3.65734 16.5605 3.44277 16.3459 3.43627 16.0793L3.41741 15.3057C3.41091 15.0391 3.19634 14.8245 2.92974 14.818L1.68011 14.7876L13.4655 3.00218L17.001 6.53771ZM19.4844 2.28657C19.9726 2.77472 19.9914 3.54735 19.5265 4.01227L17.8429 5.6959L14.3073 2.16036L15.991 0.476733C16.4559 0.0118121 17.2285 0.0306471 17.7167 0.518802L19.4844 2.28657Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
